import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Card, Row, Spinner, Modal, Dropdown } from "react-bootstrap";
import _ from "lodash";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import ApiSupplier from "../../../core/api/api.supplier";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import SwalMessage from "../_Components/SwalMessage";
import ApiOrdersService from "../../../core/api/api.ordersService";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import ModalGaranti from "./payToWarrantyModal";
import EditPayToWarrantyModal from "./EditPayToWarrantyModal";
import PayToWarrantyModal2 from "./payToWarrantyModal2";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiAgent from "../../../core/api/api.agent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";
import ApiHome from "../../../core/api/api.home";

const receiveOrPayToWarrantyEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
  { id: "2", title: "بیشتر از یکی" },
];

const promoCodeEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
];
const BasketItemPerson = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [services, setServices] = useState([]);
  const [basketItemCurrentStatus, setBasketItemCurrentStatus] = useState([]);
  const [basketCancelStatus, setBasketCancelStatus] = useState([]);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [typeOfModalWarranty, setTypeOfModalWarranty] = useState();
  const [showModalWarranty2, setShowModalWarranty2] = useState(false); //نمایش مدال پرداخت به تامین کننده
  const [ShowModalGaranty, setShowModalGaranty] = useState(false); //نمایش مدال پرداخت به گارانتی
  const [ShowModalEditWarranty, setShowModalEditWarranty] = useState(false); //نمایش مدال ویرایش گارانتی بصورت تکی
  const [suppliers, setSuppliers] = useState();
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [amusementCityList, setAmusementCityList] = useState([]);
  const [isSelectOtherCityElseKish, setIsSelectOtherCityElseKish] = useState(false)
  const pageHeight = window.innerHeight;
  //const [isExcel, setIsExcel] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm();

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);
  const [group, setGroup] = useState([]);
  const [agents, setAgents] = useState([]);
  const [commissionSettlementStatus, setCommissionSettlementStatus] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiBasketItemPerson.getAll({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          createTimeOf: searchParams.get("createTimeOf"),
          createTimeTo: searchParams.get("createTimeTo"),
          cancelStatus: _.toString(searchParams.get("cancelStatus")),
          currentStatus: _.toString(searchParams.get("currentStatus")),
          amusementGroupIds: searchParams.get("amusementGroupIds"),
          amusementServiceIds: searchParams.get("amusementServiceIds"),
          amusementServiceReserveItemIds: searchParams.get("amusementServiceReserveItemIds"),
          amusementServiceReserveItemGroupIds: searchParams.get("amusementServiceReserveItemGroupIds"),
          originalPrice: searchParams.get("originalPrice"),
          salePrice: searchParams.get("salePrice"),
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          basketItemPersonOf: searchParams.get("basketItemPersonOf"),
          basketItemPersonTo: searchParams.get("basketItemPersonTo"),
          basketIdOf: searchParams.get("basketIdOf"),
          basketIdTo: searchParams.get("basketIdTo"),
          payOrReceiveWarrantyTimeOf: searchParams.get("payOrReceiveWarrantyTimeOf"),
          payOrReceiveWarrantyTimeTo: searchParams.get("payOrReceiveWarrantyTimeTo"),
          promoCode: searchParams.get("promoCode"),
          globalSearch: searchParams.get("globalSearch"),
          receiveFromWarrantyCount: searchParams.get("receiveFromWarrantyCount"),
          payToWarrantyCount: searchParams.get("payToWarrantyCount"),
          supplierId: searchParams.get("supplierId"),
          agentId: searchParams.get("agentId"),
          transactionSupplierIdList: searchParams.get("transactionSupplierIdList"),
          supplierIdList: searchParams.get("supplierIdList"),
          commissionSettlementStatus: searchParams.get("commissionSettlementStatus"),
          cityIds: searchParams.get("cityIds"),
        });
        setListData(data);

        setValue("totalCount", data.totalCount);
        const amusementServices = await ApiAmusementService.getAllServices();
        setServices(amusementServices);
        const commissionSettlementStatusList = await ApiHome.getEnums({ enumName: "CommissionSettlementStatus" });
        if (commissionSettlementStatusList.succeeded) {
          const CommissionSettlementArray = commissionSettlementStatusList?.data?.map((item) => ({
            value: item.value,
            label: item.title,
          }));
          setCommissionSettlementStatus([{ value: undefined, label: "-------" }, ...CommissionSettlementArray]);
        }
        const suppliers = await ApiSupplier.getAllSuppliersName();
        setSuppliers(suppliers);
        const resultBasketItemCurrentStatus = await ApiOrdersService.GetEnumsName("BasketItemCurrentStatus");
        setBasketItemCurrentStatus(resultBasketItemCurrentStatus.data);

        const resultBasketCancelStatus = await ApiOrdersService.GetEnumsName("BasketCancelStatus");
        setBasketCancelStatus(resultBasketCancelStatus.data);

        const amusementGroups = await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 });
        setAmusementGroupList(amusementGroups.data);
        const cities = await ApiRegion.getAllCity();
        const kish = cities.filter(city => city.name == 'کیش').map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        const otherCities = cities.filter(city => city.name != 'کیش' && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        setAmusementCityList([
          {
            label: 'شهر های مورد علاقه',
            options: [...kish, { label: "سایر شهرها به جز کیش", value: 0 }]
          },
          {
            label: "همه شهر های ایران",
            options: otherCities
          }
        ]);
        ///////////////////////////////////////////////////////
        const agentsResponse = await ApiAgent.getAllAgent({ pageSize: 500, pageNumber: 1 });
        setAgents(agentsResponse?.data);
        const amusementItemIds = searchParams.get("amusementServiceIds")?.split(",") || [];
        const selectedServiceIds = amusementServices
          .filter((item) => amusementItemIds.includes(String(item.id)))
          ?.map((item) => ({ label: item.name, value: item.id }));

        const selectedItemsGroupIds = searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") || [];

        const selectedItemsItemIds = searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];

        inputChangeHandlerService(selectedServiceIds, true, selectedItemsGroupIds, selectedItemsItemIds);
        const mergedGroupedReserveItemsOptions = groupedReserveItemsOptions.map((item) => item.options).flat();

        const formInputs = [
          { name: "originalPrice", type: "text" },
          { name: "salePrice", type: "text" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          { name: "createTimeOf", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "firstName", type: "text" },
          { name: "cityIds", type: "multiSelect", isMulti: true, data: cities },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "basketItemPersonOf", type: "text" },
          { name: "basketItemPersonTo", type: "text" },
          { name: "basketIdOf", type: "text" },
          { name: "basketIdTo", type: "text" },
          { name: "payOrReceiveWarrantyTimeOf", type: "datePicker" },
          { name: "payOrReceiveWarrantyTimeTo", type: "datePicker" },

          { name: "promoCode", type: "multiSelect", isMulti: false, data: promoCodeEnumArray },
          { name: "currentStatus", type: "multiSelect", isMulti: true, data: resultBasketItemCurrentStatus.data },
          { name: "amusementGroupIds", type: "multiSelect", isMulti: true, data: amusementGroups.data },
          { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data: amusementServices },
          {
            name: "amusementServiceReserveItemGroupIds",
            type: "multiSelect",
            isMulti: true,
            data: mergedGroupedReserveItemsOptions?.map((optionItem) => ({
              id: optionItem.value,
              title: optionItem.label,
            })),
          },
          { name: "cancelStatus", type: "multiSelect", isMulti: true, data: resultBasketCancelStatus.data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "receiveFromWarrantyCount", type: "multiSelect", isMulti: false, data: receiveOrPayToWarrantyEnumArray },
          { name: "payToWarrantyCount", type: "multiSelect", isMulti: false, data: receiveOrPayToWarrantyEnumArray },
          {
            name: "supplierIdList",
            type: "multiSelect",
            isMulti: true,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "commissionSettlementStatus",
            type: "multiSelect",
            isMulti: false,
            data: commissionSettlementStatusList?.data?.map((item) => ({ id: item.value, title: item.title })),
          },
          {
            name: "transactionSupplierIdList",
            type: "multiSelect",
            isMulti: true,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "agentId", type: "multiSelect", isMulti: false, data: agentsResponse?.data?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);

  useEffect(() => {
    setAmusementCityList(prev => {
      const otherCities = prev[1]?.options
      const cities = prev[0]?.options
      const disabledOtherCities = otherCities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []
      const disabledCities = cities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []

      return [{ ...prev[0], options: disabledCities }, { ...prev[1], options: disabledOtherCities }]
    })

  }, [getValues("cityIds")])

  const inputChangeHandlerService = async (
    event,
    firstRender = false,
    selectedItemsGroupIds = [],
    selectedItemsItemIds = []
  ) => {
    if (!firstRender) setValue("amusementServiceIds", event);

    if (event.length > 0) {
      const responses = await Promise.all(
        event.map(async ({ value }) => {
          const reserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(value);
          const reserveItemGroups = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(value);
          return [reserveItems, reserveItemGroups, value];
        })
      );

      let groupedReserveItemsOptions = [];
      let groupedReserveItemGroupOptions = [];
      let itemList = [];
      let groupList = [];

      responses.forEach(([reserveItems, reserveItemGroups, value]) => {
        const label = event.find((item) => item.value == value)?.label;

        const optionsItems = reserveItems.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        const optionsGroups = reserveItemGroups.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        groupedReserveItemsOptions.push({ label, options: optionsGroups }); // گروه آیتم‌ها
        groupedReserveItemGroupOptions.push({ label, options: optionsItems }); // آیتم‌ها

        if (firstRender) {
          const selectedGroupItems = reserveItemGroups
            .filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          const selectedItems = reserveItems
            .filter((item) => selectedItemsItemIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          itemList.push(...selectedGroupItems);
          groupList.push(...selectedItems);
        }
      });
      setGroupedReserveItemsOptions(groupedReserveItemsOptions);
      setGroup(groupedReserveItemGroupOptions);

      if (firstRender) {
        setValue("amusementServiceReserveItemGroupIds", itemList);
        setValue("amusementServiceReserveItemIds", groupList);
      }
    } else if (event.length === 0) {
      // وقتی هیچ تفریحی انتخاب نشده
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };
  const onSubmit = async (data) => {
    if (!_.isEmpty(data.originalPrice) && !validateNumberOriginalPrice(data.originalPrice)) return;
    if (!_.isEmpty(data.salePrice) && !validateNumberSalePrice(data.salePrice)) return;
    if (!_.isEmpty(data.basketItemPersonOf) && !validateNumberBasketItemPersonOf(data.basketItemPersonOf)) return;
    if (!_.isEmpty(data.basketItemPersonTo) && !validateNumberBasketItemPersonTo(data.basketItemPersonTo)) return;
    if (!_.isEmpty(data.basketIdOf) && !validateNumberBasketIdOf(data.basketIdOf)) return;
    if (!_.isEmpty(data.basketIdTo) && !validateNumberBasketIdTo(data.basketIdTo)) return;
    if (data.supplierIdList?.length > 0) data.supplierIdList = _.toString(data.supplierIdList?.map(supplier => supplier.value));
    if (data.transactionSupplierIdList?.length > 0) data.transactionSupplierIdList = _.toString(data.transactionSupplierIdList?.map(supplier => supplier.value));
    data.supplierId = data.supplierId?.value;
    data.promoCode = data.promoCode?.value;

    data.commissionSettlementStatus = data.commissionSettlementStatus?.value;


    data.payToWarrantyCount = data.payToWarrantyCount?.value;
    data.receiveFromWarrantyCount = data.receiveFromWarrantyCount?.value;

    if (data.cancelStatus?.length > 0) data.cancelStatus = _.toString(data.cancelStatus?.map((item) => item.value));
    if (data.currentStatus?.length > 0) data.currentStatus = _.toString(data.currentStatus?.map((item) => item.value));

    if (data.cityIds?.length > 0) data.cityIds = _.toString(data.cityIds?.map((item) => item.value));

    if (data.amusementGroupIds?.length > 0)
      data.amusementGroupIds = _.toString(data.amusementGroupIds?.map((item) => item.value));

    if (data.amusementServiceIds?.length > 0)
      data.amusementServiceIds = _.toString(data.amusementServiceIds?.map((item) => item.value));

    if (data.amusementServiceReserveItemGroupIds?.length > 0)
      data.amusementServiceReserveItemGroupIds = _.toString(
        data.amusementServiceReserveItemGroupIds?.map((item) => item.value),
      );

    if (data.amusementServiceReserveItemIds?.length > 0)
      data.amusementServiceReserveItemIds = _.toString(data.amusementServiceReserveItemIds?.map((item) => item.value));

    if (data.payOrReceiveWarrantyTimeOf !== null && typeof data.payOrReceiveWarrantyTimeOf === "object") {
      data.payOrReceiveWarrantyTimeOf = tools.DateFormat(data.payOrReceiveWarrantyTimeOf);
    }
    if (data.payOrReceiveWarrantyTimeTo !== null && typeof data.payOrReceiveWarrantyTimeTo === "object") {
      data.payOrReceiveWarrantyTimeTo = tools.DateFormat(data.payOrReceiveWarrantyTimeTo);
    }
    if (data.useTimeOf !== null && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo !== null && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.createTimeOf !== null && typeof data.createTimeOf === "object") {
      data.createTimeOf = tools.DateFormat(data.createTimeOf);
    }
    if (data.createTimeTo !== null && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (!_.isEmpty(data.salePrice)) data.salePrice = data.salePrice.replaceAll(",", "");
    if (!_.isEmpty(data.originalPrice)) data.originalPrice = data.originalPrice.replaceAll(",", "");
    data.agentId = _.toString(data.agentId?.value);

    tools.setPageNumber(data, searchParams, setValue);
    //if (isExcel) {
    //  ApiBasketItemPerson.getBasketItemPersonsReportByExcel(data).then((response) => {
    //    const fileBlobUrl = URL.createObjectURL(new Blob([response]));
    //    const anchor = document.createElement("a");
    //    anchor.style.display = "none";
    //    anchor.id = "file" + Math.floor(Math.random() * 100);
    //    anchor.href = fileBlobUrl;
    //    anchor.download = "Report.xlsx";
    //    document.body.appendChild(anchor);
    //    anchor.click();
    //  });
    //} else {
    const apiData = await ApiBasketItemPerson.getAll(data);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/basketItemPerson?${queryString}`);
    setListData(apiData);
    setSelectedCheckBoxes([]);
    setValue("totalCount", apiData.totalCount);
    //}
  };
  const showModalPayToWarranty2 = async (data) => {
    setShowModalWarranty2(true);
  };
  const handleModalGaranty = (current, typeOfModal) => {
    setTypeOfModalWarranty(typeOfModal);
    if (current == 0) {
      SwalMessage({
        title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else if (
      (typeOfModal === "editPayToWarranty" || typeOfModal === "editReceiveFromWarranty") &&
      String(current).split(",").length === 1
    ) {
      setShowModalEditWarranty(true);
    } else setShowModalGaranty(true);
  };

  function handleChangeMultiCurrentStatus(value) {
    setValue("currentStatus", value);
  }
  function handleChangeMultiCancelStatus(value) {
    setValue("cancelStatus", value);
  }
  let typeOfModalWarrantyText;
  (async () => {
    switch (typeOfModalWarranty) {
      case "payToWarranty":
        typeOfModalWarrantyText = "پرداخت به تامین کننده";
        break;
      case "receiveFromWaranty":
        typeOfModalWarrantyText = "دریافت از تامین کننده";
        break;
      case "editPayToWarranty":
        typeOfModalWarrantyText = "ویرایش پرداخت به تامین کننده";
        break;
      case "editReceiveFromWarranty":
        typeOfModalWarrantyText = "ویرایش دریافت از تامین کننده";
        break;
    }
  })();

  useEffect(() => {
    if (ShowModalEditWarranty) {
      // Disable scroll when modal is open
      document.documentElement.style.overflow = "hidden"; // جلوگیری از اسکرول کل صفحه
      document.body.style.overflow = "hidden"; // جلوگیری از اسکرول body
    } else {
      // Enable scroll when modal is closed
      document.documentElement.style.overflow = "auto"; // فعال کردن اسکرول برای کل صفحه
      document.body.style.overflow = "auto"; // فعال کردن اسکرول برای body
    }

    // Cleanup the effect when the component is unmounted
    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    };
  }, [ShowModalEditWarranty]);

  const validateNumberOriginalPrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("originalPrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("originalPrice");
      return true;
    }
  };

  const validateNumberSalePrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("salePrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("salePrice");
      return true;
    }
  };

  const validateNumberBasketItemPersonOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonOf", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonOf");
      return true;
    }
  };
  const validateNumberBasketItemPersonTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonTo", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonTo");
      return true;
    }
  };

  const validateNumberBasketIdOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdOf", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdOf");
      return true;
    }
  };
  const validateNumberBasketIdTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdTo", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdTo");
      return true;
    }
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت بلیط ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست بلیط ها</span>
          </h3>
          <Dropdown className=" sticky-top " style={{ position: "fixed", top: pageHeight / 2, left: "-16px" }}>
            <Dropdown.Toggle size="sm" drop="up" variant="primary" className=" position-absolute right-0 fa-rotate-270">
              عملیات{" "}
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-2">
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleModalGaranty(selectedCheckBoxes, "payToWarranty")}
                >
                  پرداخت به تامین کننده
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleModalGaranty(selectedCheckBoxes, "editPayToWarranty")}
                >
                  ویرایش پرداخت به تامین کننده
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleModalGaranty(selectedCheckBoxes, "receiveFromWaranty")}
                >
                  دریافت از تامین کننده
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleModalGaranty(selectedCheckBoxes, "editReceiveFromWarranty")}
                >
                  ویرایش دریافت از تامین کننده
                </button>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}

              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body className="pt-0">
                        <Row>
                          <Col sm="6" xl="3" className="tb-responsive px-2 mb-1 mt-5">
                            <Controller
                              name="createTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <ShamsiDatePicker
                                    value={value}
                                    onChange={(date) => {
                                      var createTimeTo = getValues("createTimeTo");
                                      onChange(date);
                                      if (
                                        !createTimeTo ||
                                        (date?.toDate && date?.toDate()?.getTime() > new Date(createTimeTo).getTime())
                                      ) {
                                        // Set the value of createTimeTo to the same as createTimeTo
                                        setValue("createTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان ایجاد از"
                                  />
                                );
                              }}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="createTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ایجاد تا" />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="useTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={(date) => {
                                    var useTimeTo = getValues("useTimeTo");
                                    onChange(date);
                                    if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                      // Set the value of useTimeTo to the same as useTimeOf
                                      setValue("useTimeTo", date);
                                    }
                                  }}
                                  placeholder="زمان انجام تفریح از"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="useTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان انجام تفریح تا" />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketItemPersonOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره بلیط از "
                                  size="small"
                                  className="mt-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonOf && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketItemPersonTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره بلیط تا "
                                  size="small"
                                  className="mt-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonTo && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonTo.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketIdOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره سفارش از"
                                  className="mt-5"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdOf && (
                              <div className="text-small-1 text-danger"> {errors.basketIdOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketIdTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  className="mt-5"
                                  label="شماره سفارش تا"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdTo && (
                              <div className="text-small-1 text-danger"> {errors.basketIdTo.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  className="mt-3"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  className="mt-3"
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  className="mt-3"
                                  type="search"
                                  customInput={TextField}
                                  label="شماره موبایل"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onChange={onChange}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="currentStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  placeholder="وضعیت سفارش"
                                  className="mt-3"
                                  options={[
                                    {
                                      value: "0,2",
                                      label: "0-جدید و 2-رهاسازی",
                                    },
                                    ...basketItemCurrentStatus
                                      .filter((item) => item.id != 0 && item.id != 2)
                                      .map((item) => ({
                                        value: item.id,
                                        label: item.id + "-" + item.title,
                                      })),
                                  ]}
                                  onChange={handleChangeMultiCurrentStatus}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="cancelStatus"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  placeholder="وضعیت کنسل"
                                  className="mt-3"
                                  options={basketCancelStatus?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.title,
                                  }))}
                                  field={field}
                                  onChange={handleChangeMultiCancelStatus}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="originalPrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="نرخ مصوب "
                                  className="mt-3"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.originalPrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOriginalPrice(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.originalPrice && (
                              <div className="text-small-1 text-danger"> {errors.originalPrice.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="salePrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="نرخ فروش "
                                  className="mt-3"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.salePrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberSalePrice(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.salePrice && (
                              <div className="text-small-1 text-danger"> {errors.salePrice.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="cityIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder="شهر"
                                  options={amusementCityList}
                                  isMulti
                                  field={field}
                                  onChange={(selectedCities) => {
                                    let confirmValues = selectedCities;
                                    if (selectedCities.find(item => item.value == 0)) {
                                      setIsSelectOtherCityElseKish(true)
                                      confirmValues = selectedCities.filter(city => city.value == 0)
                                    }
                                    else
                                      setIsSelectOtherCityElseKish(false)
                                    field.onChange(confirmValues)
                                  }}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder=" دسته تفریح"
                                  options={amusementGroupList?.map((item) => ({ value: item.id, label: item.title }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder="تفریح"
                                  options={services?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  field={field}
                                  onChange={(e) => inputChangeHandlerService(e)}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceReserveItemGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-3"
                                  placeholder="گروه آیتم"
                                  options={groupedReserveItemsOptions || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceReserveItemIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-3"
                                  placeholder="آیتم"
                                  options={group || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>


                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="supplierIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="تامین کننده آیتم"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="promoCode"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="کد تخفیف"
                                  options={promoCodeEnumArray?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-5"
                                  placeholder="نماینده فروش "
                                  options={agents?.map((item) => ({ value: item.id, label: item.companyName }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="commissionSettlementStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  options={commissionSettlementStatus}
                                  placeholder="وضعیت کمیسیون نماینده "
                                  field={field}
                                />
                              )}
                            />
                          </Col>


                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payToWarrantyCount"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="پرداخت به تامین کننده"
                                  options={receiveOrPayToWarrantyEnumArray?.map(({ id: value, title: label }) => ({
                                    value,
                                    label,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="receiveFromWarrantyCount"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="دریافت از تامین کننده"
                                  options={receiveOrPayToWarrantyEnumArray?.map(({ id: value, title: label }) => ({
                                    value,
                                    label,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payOrReceiveWarrantyTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={(date) => {
                                    var payOrReceiveWarrantyTimeTo = getValues("payOrReceiveWarrantyTimeTo");
                                    onChange(date);
                                    if (
                                      !payOrReceiveWarrantyTimeTo ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(payOrReceiveWarrantyTimeTo).getTime())
                                    ) {
                                      // Set the value of payOrReceiveWarrantyTimeTo to the same as useTimeOf
                                      setValue("payOrReceiveWarrantyTimeTo", date);
                                    }
                                  }}
                                  placeholder="زمان پرداخت به تامین کننده از"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payOrReceiveWarrantyTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="زمان پرداخت به تامین کننده تا"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="transactionSupplierIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="تامین کننده پرداخت شده"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-5">
                          <Col xs="12" className=" px-2 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting} className="mb-2">
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>

                            <Button
                              className="ml-3 mb-2"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsSelectOtherCityElseKish(false)
                                tools.handleResetAdvanceSearchBox(watch, reset)
                              }}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-3 mb-2 btn btn-outline-primary"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={methods.handleSubmit((data) => showModalPayToWarranty2(data))}
                            >
                              <i className="fas fa-credit-card text-small"></i>
                              پرداخت به تامین کننده
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SearchIcon />{" "}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className=" px-0">
                <DataGrid
                  data={listData}
                  setSelectedCheckBoxes={setSelectedCheckBoxes}
                  selectedCheckBoxes={selectedCheckBoxes}
                />
              </Col>
            </form>
          </FormProvider>
          {showModalWarranty2 && (
            <PayToWarrantyModal2
              showModalWarranty2={showModalWarranty2}
              setShowModalWarranty2={setShowModalWarranty2}
              formData={(() => {
                const formValues = methods.getValues();
                return {
                  ...formValues,
                  // تبدیل فیلدهای تاریخ برای نمایش با فرمت درست روی مدال
                  createTimeOf:
                    formValues.createTimeOf && typeof formValues.createTimeOf === "object"
                      ? tools.DateFormat(formValues.createTimeOf)
                      : formValues.createTimeOf,
                  createTimeTo:
                    formValues.createTimeTo && typeof formValues.createTimeTo === "object"
                      ? tools.DateFormat(formValues.createTimeTo)
                      : formValues.createTimeTo,
                  useTimeOf:
                    formValues.useTimeOf && typeof formValues.useTimeOf === "object"
                      ? tools.DateFormat(formValues.useTimeOf)
                      : formValues.useTimeOf,
                  useTimeTo:
                    formValues.useTimeTo && typeof formValues.useTimeTo === "object"
                      ? tools.DateFormat(formValues.useTimeTo)
                      : formValues.useTimeTo,
                  payOrReceiveWarrantyTimeOf:
                    formValues.payOrReceiveWarrantyTimeOf && typeof formValues.payOrReceiveWarrantyTimeOf === "object"
                      ? tools.DateFormat(formValues.payOrReceiveWarrantyTimeOf)
                      : formValues.payOrReceiveWarrantyTimeOf,
                  payOrReceiveWarrantyTimeTo:
                    formValues.payOrReceiveWarrantyTimeTo && typeof formValues.payOrReceiveWarrantyTimeTo === "object"
                      ? tools.DateFormat(formValues.payOrReceiveWarrantyTimeTo)
                      : formValues.payOrReceiveWarrantyTimeTo,
                };
              })()}
            />
          )}
          <Modal
            centered
            dialogClassName="modal-90w"
            show={ShowModalGaranty}
            onHide={() => setShowModalGaranty(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{typeOfModalWarrantyText}</Modal.Title>
            </Modal.Header>
            <ModalGaranti
              typeOfModalWaranty={typeOfModalWarranty}
              selectedItem={selectedCheckBoxes}
              setShowModalGaranty={setShowModalGaranty}
            />
          </Modal>
          <Modal
            centered
            dialogClassName="modal-90w"
            show={ShowModalEditWarranty}
            onHide={() => setShowModalEditWarranty(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{typeOfModalWarrantyText}</Modal.Title>
            </Modal.Header>
            <EditPayToWarrantyModal
              typeOfModalWaranty={typeOfModalWarranty}
              selectedItem={selectedCheckBoxes}
              setShowModalEditWarranty={setShowModalEditWarranty}
            />
          </Modal>

          {/* <DevTool control={control} /> */}
        </div>
      </div>
    </div>
  );
};

export default BasketItemPerson;
